import { useContext } from 'react';
import { ServiceConfigContext } from '../contexts/ServiceConfig';

const useServices = () => {
  const context = useContext(ServiceConfigContext);

  if (!context) throw new Error('In order to use a service module, it needs to be wrapped in a ServiceConfigProvider');

  return context;
};

export default useServices;
